<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Account List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="userCreate"
              >
                <CIcon name="cil-user-follow" />
              </CButton>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search By Username"
                    @input="searchAccount($event, '')"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="20"
            clickable-rows
            :active-page="1"
            :pagination="false"
            @page-change="pageChange"
          >
            <template #acount_id="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-0"
                    @click="rowClicked(data.item.account_id)"
                    >Detail</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="searchAccount('', 'REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="searchAccount('', 'BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div class="pagination-btn-next" @click="searchAccount('', 'NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import moment from "moment";

export default {
  name: "Users",
  data() {
    return {
      items: [],
      fields: [
        { key: "account_id", label: "ID" },
        { key: "account_group" },
        { key: "account_name" },
        { key: "username" },
        { key: "email" },
        { key: "status" },
        { key: "created_at" },
        { key: "created_by" },
        { key: "updated_at" },
        { key: "updated_by" },
        { key: "acount_id", label: "Action" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.searchAccount("", "");
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getBadge(status) {
      switch (status) {
        case "NEW":
          return "success";
        case "FOLLOW UP":
          return "secondary";
      }
    },
    searchAccount(event, action) {
      if (action === "NEXT") {
        this.activePage = this.activePage + 1;
      } else if (action === "BACK") {
        if (this.activePage > 1) {
          this.activePage = this.activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        this.activePage = 1;
        window.scrollTo(0, 0);
      } else {
        this.activePage = 1;
      }
      axios
        .get(
          `${this.domain}/v1/account/data?page=${this.activePage}&per_page=20&q=${event}`,
          {
            headers: {
              Authorization: this.token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          // JSON responses are automatically parsed.
          if (response.data.data.length > 0) {
            if (this.activePage > 1) {
              window.scrollTo(0, 0);
            }
            var accountGroup = "ADMIN";
            this.items = response.data.data.filter(function(acount) {
              return acount.account_group !== accountGroup;
            });
            this.items.forEach((element) => {
              element.created_at = moment(String(element.updated_at)).format(
                "MM/DD/YYYY hh:mm A"
              );
              element.updated_at = moment(String(element.created_at)).format(
                "MM/DD/YYYY hh:mm A"
              );
            });
          } else if (action === "NEXT") {
            this.activePage = this.activePage - 1;
          } else if (response.data.data.length === 0 && action === "") {
            this.items = response.data.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/account/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    userCreate() {
      this.$router.push({ path: `/management/account/create` });
    },
  },
};
</script>

<style scoped>
@import "./User.css";
</style>
